import React from 'react';
import { Helmet } from 'react-helmet';

interface StructuredDataProps {
    faqSchemaOrgJSONLD?: any;
    isFaqPage?: boolean;
    isHomePage?: boolean;
    pathname?: string;
}

const StructuredData: React.FC<StructuredDataProps> = ({
    faqSchemaOrgJSONLD,
    isFaqPage = false,
    isHomePage = false,
    pathname = ''
}) => {
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "Hyperhuman",
        "url": "https://hyperhuman.cc",
        "image": "https://images.prismic.io/hyperhuman/Z-gcWXdAxsiBwFTC_hyperhuman-logo-seo.jpg",
        "description": "Hyperhuman is an AI-powered, web-based platform for creating, personalizing, and distributing fitness, wellness, and health video content at scale.",
        "applicationCategory": "VideoApplication",
        "operatingSystem": "Web",
        "softwareVersion": "2.76",
        "offers": {
            "@type": "Offer",
            "price": "0.00",
            "priceCurrency": "USD",
            "description": "Test the platform for free and create up to 30 minutes of high-quality video content. No credit card required."
        },
        "creator": {
            "@type": "Organization",
            "name": "Hyperhuman",
            "url": "https://hyperhuman.cc",
            "logo": "https://images.prismic.io/hyperhuman/Z-gcWXdAxsiBwFTC_hyperhuman-logo-seo.jpg"
        }
    };

    const orgSchema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Hyperhuman",
        "url": "https://hyperhuman.cc",
        "logo": "https://images.prismic.io/hyperhuman/Z-gcWXdAxsiBwFTC_hyperhuman-logo-seo.jpg",
        "sameAs": [
            "https://youtube.com/@hyperhumancc",
            "https://www.instagram.com/hyperhumancc",
            "https://www.linkedin.com/company/hyperhuman",
            "https://www.facebook.com/hyperhumancc",
            "https://twitter.com/hyperhumancc",
            "https://www.tiktok.com/@hyperhumancc"
        ]
    };

    const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
            {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://hyperhuman.cc"
            },
            ...(pathname && pathname !== "/" ? [
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": pathname.slice(1).charAt(0).toUpperCase() + pathname.slice(2).replace(/-/g, ' '),
                    "item": `https://hyperhuman.cc${pathname}`
                }
            ] : [])
        ]
    };

    return (
        <Helmet>
            {isFaqPage && faqSchemaOrgJSONLD && (
                <script type="application/ld+json">{JSON.stringify(faqSchemaOrgJSONLD)}</script>
            )}
            <script type="application/ld+json">{JSON.stringify(productSchema)}</script>
            <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
            <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
        </Helmet>
    );
};

export default StructuredData; 